import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { requestScoreboardInformation } from 'services/smartguard/duck';
import { LoadingTile } from 'components/molecules/ErrorTile';
import ScoreboardView from 'components/organisms/smartguard/ScoreboardView';

const ScoreboardContainer = ({
    scoreboardInfo,
    dispatch
}) => {
    useEffect(() => {
        dispatch(requestScoreboardInformation());
    }, []);

    if (!scoreboardInfo) {
        return <LoadingTile />;
    }

    const {
        scoreboard = {},
        rules = [],
    } = scoreboardInfo || {};

    return <ScoreboardView scoreboard={scoreboard} rules={rules} />;
};

ScoreboardContainer.propTypes = {
    scoreboardInfo: PropTypes.object,
};

const mapStateToProps = state => ({
    scoreboardInfo: state.smartguard.scoreboard,
});

export default connect(mapStateToProps)(ScoreboardContainer);



// WEBPACK FOOTER //
// ./src/containers/smartguard/ScoreboardContainer.js